/** Ortho half-extent of the sun, matched to the chase-camera height. */
export function shadowExtent(cameraHeight: number): number {
  return Math.min(40, Math.max(28, cameraHeight * 1.15));
}

/** Inclusive XZ reach test that does not take a square root. */
export function withinReach(ax: number, az: number, bx: number, bz: number, reach: number): boolean {
  const dx = ax - bx;
  const dz = az - bz;
  return dx * dx + dz * dz <= reach * reach;
}
